module.exports = __webpack_public_path__ + "static/media/apple-crate.94e5be1f.svg";